import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

const CUSTOMER_FAVORITE_GAMES_ENDPOINT = "v1/currentcustomergames";

@Injectable({
	providedIn: "root",
})
export class FavouriteGamesConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getCacheMaxAgeDefault(): number {
		return fromMinutesToMilliseconds(this.service.get((x) => x.gaming.favourites.cache!.default, 30));
	}

	getCacheMaxAgeForGetAll(): number {
		return this.service.get((x) => x.gaming.favourites.cacheMaxAge!.getAll, this.getCacheMaxAgeDefault());
	}

	getAllEndpoint(): string {
		return this.service.get(
			(x) => x.gaming.favourites.endpoints!.getAll,
			`${CUSTOMER_FAVORITE_GAMES_ENDPOINT}/favourites/?$fields=id`
		);
	}

	addRemoveEndpoint(): string {
		return this.service.get(
			(x) => x.gaming.favourites.endpoints!.addRemove,
			`${CUSTOMER_FAVORITE_GAMES_ENDPOINT}/favourites/:id`
		);
	}

	getGameIdsHiddenFromFavourites(): string[] {
		return this.service.get((x) => x.gaming.favourites.gameIdsHiddenFromFavourites, []);
	}

	getUseGameIdForSIBrands(): boolean {
		return this.service.get((x) => x.gaming.favourites.useGameIdForSIBrands, true);
	}
}
